import React from "react";
import RadiusSlider from "./Filters/RadiusSlider";
import GenderFilter from "./Filters/GenderFilter";
import AgeFilter from "./Filters/AgeFilter";
import OpenFilter from "./Filters/OpenFilter";
import TargetPopulations from "./Filters/TargetPopulations";
import ReferralFilter from "./Filters/ReferralFilter";
import AreaSort from "./Filters/AreaSort";

function SearchFiltersPanel({
  advancedFilters,
  targetPopulations,
  selectedTargetPopulations,
  onTargetPopulationChange,
  hasNonDefaultServiceArea,
  radius,
  onRadiusChange,
  openNow,
  openOn,
  onOpenNowChange,
  onOpenOnChange,
  gender,
  onGenderChange,
  ageRange,
  onAgeRangeChange,
  areaSort,
  onAreaSortChange,
  referral,
  onReferralChange,
  stateAbbr,
  onApplyFilters,
  onClearFilters,
  applyButtonLabel = "Apply Filters to Current Results",
  applyButtonDisabled = false,
}) {
  return (
    <div className="filters">
      <div className="target-and-search-horizontal">
        <div className="target-population-region">
          {advancedFilters.targetPopulation && (
            <TargetPopulations
              populations={targetPopulations || []}
              selected={selectedTargetPopulations || []}
              onChange={onTargetPopulationChange}
            />
          )}
        </div>
        <div className="search-radius-region">
          {hasNonDefaultServiceArea && advancedFilters.radius !== false && (
            <RadiusSlider value={radius} onChange={onRadiusChange} />
          )}
        </div>
      </div>
      <div className="open-filter-region">
        {(advancedFilters.openNow || advancedFilters.daysOpen) && (
          <OpenFilter
            openNow={openNow}
            openOn={openOn}
            onOpenNowChange={onOpenNowChange}
            onOpenOnChange={onOpenOnChange}
            showOpenNow={!!advancedFilters.openNow}
            showDaysOpen={!!advancedFilters.daysOpen}
          />
        )}
      </div>
      <div className="gender-filter-region">
        {advancedFilters.gender && (
          <GenderFilter
            value={gender}
            onChange={onGenderChange}
            nonBinary={advancedFilters.gender === "non-binary"}
          />
        )}
      </div>
      <div className="age-filter-region">
        {advancedFilters.age && (
          <AgeFilter value={ageRange} onChange={onAgeRangeChange} />
        )}
      </div>
      <div className="area-sort-region">
        {advancedFilters.areaSort && (
          <AreaSort value={areaSort} onChange={onAreaSortChange} stateAbbr={stateAbbr} />
        )}
      </div>
      <div className="referral-filter-region">
        {advancedFilters.referral && (
          <ReferralFilter value={referral} onChange={onReferralChange} />
        )}
      </div>
      <a className="clear-link" onClick={onClearFilters} role="button" tabIndex={0}>
        Clear All Filters
      </a>
      <div className="apply-filters-footer">
        <button className="apply-filters btn btn-secondary" onClick={onApplyFilters} disabled={applyButtonDisabled}>
          {applyButtonLabel}
        </button>
      </div>
    </div>
  );
}

export default SearchFiltersPanel;
